import { Box, Button, Dialog, DialogActions, DialogContent, useMediaQuery, useTheme } from '@mui/material';
import * as React from 'react';
import { MessageInfo } from '../../../models/MessageInfo';

interface MessageDialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  message: string | undefined;
  severity?: 'error' | 'warning' | 'info' | 'success';
  primaryAction?: {
    text: string;
    handler: (e: CustomEvent) => void;
  };
  secondaryAction?: {
    text: string;
    handler: (e: CustomEvent) => void;
  };
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export default function MessageDialog(props: MessageDialogProps) {
    // const [showMessageInfo, isMessageInfoShow] = React.useState<boolean>(props.open);
    // const [messageInfo, setMessageInfo] = React.useState<MessageInfo>({
    //     message: props.message,
    //     messageType: 'danger',
    //     header: props.title,
    //     primaryText: 'OK',
    // });
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleAction = (e: React.MouseEvent, callback?: (e: CustomEvent) => void) => {
        //isMessageInfoShow(false); // Close dialog first
        callback?.(new CustomEvent('button-click', { detail: e }));
        props.onClose();
    };
    
    return (
        <Dialog
        open={props.open}
        onClose={props.onClose}
        maxWidth="sm" // 'xs' | 'sm' | 'md' | 'lg' | 'xl'
        fullWidth={isMobile} // Full width on mobile
        sx={{
          '& .MuiDialog-paper': {
            minWidth: isMobile ? '90vw' : 400, // Responsive min-width
            p: 2,
          }
        }}
      >
        {/* Message Content */}
        <DialogContent>
          <Box
            sx={{
              whiteSpace: 'pre-line',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              maxHeight: '60vh',
              overflowY: 'auto',
              fontSize: isMobile ? '0.875rem' : '1rem',
            }}
          >
            {props.message}
          </Box>
        </DialogContent>

        {/* Action Buttons */}
        <DialogActions
          sx={{
            flexDirection: isMobile ? 'column' : 'row', // Stack vertically on mobile
            gap: 1,
            px: 2,
            pb: 2,
          }}
        >
          {props.secondaryAction?.text && (
            <Button
              variant="outlined"
              onClick={(e) => handleAction(e, props.secondaryAction?.handler)}
              fullWidth={isMobile} // Full width on mobile
            >
              {props.secondaryAction.text}
            </Button>
          )}

          {props.primaryAction?.text && (
            <Button
              variant="contained"
              onClick={(e) => handleAction(e, props.primaryAction?.handler)}
              fullWidth={isMobile} // Full width on mobile
              sx={{ ml: isMobile ? 0 : 1 }} // Add left margin only on desktop
            >
              {props.primaryAction.text}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    );
}